<template>
    <div class="totem-datepicker">
        <datepicker
            type="text"
            :input-class="['totem-input__field totem-input-datepicker', 'medium']"
            :language="language"
            :format="format"
            v-model="localDate"
            :placeholder="placeholder"
            :disabled="disabled"
            :monday-first="true"
            :style="cssVars"
            :clear-button="clearButton"
            :disabled-dates="disabledDates"
            clear-button-icon="icon-cancel"
            calendar-class="totem-datepicker"
            :calendar-button="true"
        />
        <label class="totem-datepicker__label" v-html="label"></label>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
    import * as locales from 'vuejs-datepicker/dist/locale/'
    import { mapGetters } from 'vuex'

    export default {
        name: 'totem-datepicker',
        components: {
            Datepicker
        },
        props: {
            format: {
                type: String,
                default: 'dd.MM.yyyy'
            },
            placeholder: String,
            label: {
                type: String,
                default: ''
            },
            value: [ String, Date ],
            disabled: Boolean,
            width: {
                type: Number,
                default: 285
            },
            clearButton: {
                type: Boolean,
                default: false
            },
            disabledDates: Object
        },
        computed: {
            ...mapGetters({
                selectedCountryCode: 'Languages/getSelectedCountryCode'
            }),
            language () {
                switch (this.selectedCountryCode) {
                case 'no':
                    return locales.nbNO
                case 'se':
                    return locales.sv
                default:
                    return locales[this.selectedCountryCode]
                }
            },
            cssVars () {
                return {
                    '--width': this.width + 'px'
                }
            },
            localDate: {
                get () {
                    return this.value
                },
                set (value) {
                    this.$emit('input', value)
                }
            }
        },
        methods: {
            clearWithoutEmit () {
                this.localDate = null
            }
        },
        created () {
            if (this.value !== null && this.value !== '') {
                this.localDate = new Date(this.value)
            }
        }
    }
</script>

<style lang="scss">
    .totem-datepicker {
        position: relative;

        &__label {
            font-family: PlusJakartaSans-Bold, sans-serif;
            font-size: 1rem;
            line-height: 1.2rem;
            letter-spacing: 1.5px;
            color: $lavender;
            text-transform: uppercase;
            position: absolute;
            top: 10px;
            left: 20px;

            &.required {
                &:after {
                    content: ' *';
                }
            }
        }

        .totem-input__field {

        }
    }

    .vdp-datepicker {
        width: var(--width);

        [class*="mobile"] & {
            width: 100%;
        }

        &:first-child {
            position: relative;
        }

        &__clear-button,
        &__calendar-button {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
        }

        &__calendar-button {
            > span {
                display: none;
            }
            &:after {
                content: "\e946";
                font-family: 'icomoon';
                color: $lavender;
            }
        }

        .totem-input-datepicker {
            padding: 16px 20px 3px 20px;
        }
    }

    .totem-datepicker.vdp-datepicker {
        &__calendar {
            header {
                display: flex;
                justify-content: space-between;
            }

            .day__month_btn,
            .month__year_btn {
                position: relative;
                width: auto;
                text-decoration: underline;
                padding: 0 40px;

                &:after {
                    content: "\e933";
                    font-family: 'icomoon';
                    position: absolute;
                    right: 18px;
                    font-size: 2rem;
                }
            }
        }
    }
</style>
